<!--设置司机-->
<template>
  <el-dialog
    ref="modifyDriver"
    title="设置司机信息"
    :visible.sync="visible"
    :append-to-body="true"
    width="50%"
  >
    <el-form
      ref="query"
      :model="query"
      size="small"
      :inline="true"
      label-width="88px"
      @submit.native.prevent
    >
      <el-form-item label="司机信息" prop="searchKey">
        <el-input v-model="query.searchKey" clearable placeholder="搜索司机信息" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click.stop="search">搜索</el-button>
        <el-button type="danger" @click.stop="reset">清空</el-button>
      </el-form-item>
      <el-form-item>
        <div class="tipsBox">
          <img style="width: 20px; height: 20px" src="./static/tips.png" />
          <span>支持通过司机姓名、手机号搜索司机！</span>
        </div>
      </el-form-item>
    </el-form>
    <el-table
      :data="data"
      stripe
      highlight-current-row
      border
      max-height="300px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" align="center" width="55" />
      <el-table-column label="司机" align="center">
        <template slot-scope="scope">
          {{ scope.row.driverName + ' ' + scope.row.driverPhone }}
        </template>
      </el-table-column>
      <el-table-column label="车牌" align="center" prop="carNumber" />
      <el-table-column label="车型" align="center">
        <template slot-scope="scope"> {{ scope.row.seats }} 座 </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="page.current"
      :limit.sync="page.size"
      @pagination="refresh"
    />
    <div class="tipsBox" style="margin: 0 0 0 50px">
      <img style="width: 20px; height: 20px" src="./static/tips.png" />
      <span>勾选司机后点击保存即可！</span>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click.stop="cancel">取 消</el-button>
      <el-button type="primary" size="small" @click.stop="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { getDriver, modifyDr } from '@/api/transport/bustime'
  export default {
    name: 'setDriver',
    data() {
      return {
        visible: false,
        driverName: '',
        lineId: '',
        flightPlanId: '',
        merchantId: '',
        priceMethodId: '',
        query: {},
        page: {
          current: 1,
          size: 10
        },
        form: {},
        total: 0,
        data: [],
        selections: []
      }
    },
    methods: {
      init(row) {
        this.visible = true
        this.data = []
        this.flightPlanId = row.flightPlanId
        this.merchantId = row.merchantId
        this.priceMethodId = row.priceMethodId
        this.lineId = row.lineId
        this.onLoad(this.page)
      },
      search() {
        this.page.current = 1
        // this.data = []
        this.onLoad(this.page, this.query)
      },
      refresh() {
        this.onLoad(this.page)
      },
      reset() {
        this.query.searchKey = ''
        this.onLoad(this.page)
        // this.data = []
      },
      async onLoad(page, params = {}) {
        const query = {
          current: this.page.current,
          size: this.page.size,
          priceMethodId: this.priceMethodId,
          merchantId: this.merchantId,
          lineId: this.lineId,
          ...this.query
        }
        await getDriver(Object.assign(query, params)).then((resp) => {
          this.data = resp.data.records
          this.total = resp.data.total
        })
      },
      handleSelectionChange(arry) {
        if (arry) {
          this.selections = arry
          // this.form.driverId = val.driverId
          // this.form.carId = Number.parseInt(val.carId)
        }
      },
      save() {
        if (this.selections.length === 0) {
          this.$message.warning('请选择司机')
          return
        }
        if (this.selections.length > 1) {
          this.$message.warning('只能选择一位司机')
          return
        }
        this.form.driverId = this.selections[0].driverId
        this.form.carId = Number.parseInt(this.selections[0].carId)
        this.form.flightPlanId = this.flightPlanId
        modifyDr(this.form).then((resp) => {
          if (resp.code === 0) {
            this.$message.success('调整成功')
            this.$emit('refreshData')
          }
          this.visible = false
          this.reset()
        })
      },
      cancel() {
        this.reset()
        this.visible = false
      }
    }
  }
</script>

<style scoped>
  .tipsBox {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #9f9f9f;
  }
  .tipsBox span {
    margin-left: 5px;
  }
</style>
